module.exports = __webpack_public_path__ + "img/carrier-bags.da2960ac.jpg";